export const UPDATE_LAST_TORCH = 'UPDATE_LAST_TORCH'

export function lastTorchGeolocationReducer (state = {}, action) {
    switch (action.type){
        case UPDATE_LAST_TORCH:
            return action.payload
        default: return state
    }
}